module.exports = __webpack_public_path__ + "img/expostyle_1681_jade_pantone2241c.bd397e7e.jpg";